import { Component } from '@angular/core';

import { ButtonComponent } from '../../../../../../../shared/button/button.component';
import { LoaderTesteComponent } from '../../../../../../../shared/loader/loader-teste/loader-teste.component';
import { LoaderService } from '../../../../../../../shared/loader/loader.service';
import { ModalService } from '../../../../../../../shared/modal/modal.service';
import { StorageServiceService } from '../../../../../../../shared/storage/storage-service.service';
import { ToastService } from '../../../../../../../shared/toast/toast.service';
import { AlunosService } from '../../../../alunos/alunos.service';
import { FilesService } from '../../../../../../../shared/services/files/files.service';
import {
  contentType,
  field,
} from '../../../../../../../models/files.interface';

@Component({
  selector: 'app-fotos-aluno',
  standalone: true,
  imports: [ButtonComponent, LoaderTesteComponent],
  templateUrl: './fotos-aluno.component.html',
  styleUrl: './fotos-aluno.component.scss',
})
export class FotosAlunoComponent {
  fotoFrontal: File | undefined;
  fotoFrontalCapturadaUrl: string | undefined;

  fotoDireito: File | undefined;
  fotoDireitoCapturadaUrl: string | undefined;

  fotoEsquerdo: File | undefined;
  fotoEsquerdoCapturadaUrl: string | undefined;

  documentIdAluno!: string | undefined;
  idAluno!: number | undefined;

  aluno: any;

  constructor(
    private readonly modalService: ModalService,
    private readonly alunosService: AlunosService,
    private readonly loaderService: LoaderService,
    private readonly toast: ToastService,
    private readonly storageService: StorageServiceService,
    private readonly filesService: FilesService,
  ) {
    this.alunosService.alunoSelecionado.subscribe((value) => {
      if (value === null) {
        this.documentIdAluno = this.storageService.obterAluno()?.documentId;
        this.idAluno = this.storageService.obterAluno()?.id;
      } else {
        this.documentIdAluno = value?.documentId;
        this.idAluno = value?.id;
      }
      this.buscarAlunoPorId();
    });
  }

  getFotoUrlFrontal(idFoto: number): void {
    this.loaderService
      .executeWithLoader(this.alunosService.buscarFotoPorId(idFoto))
      .subscribe({
        next: (blob: Blob) => {
          const url = URL.createObjectURL(blob);
          this.fotoFrontalCapturadaUrl = url;
        },
        error: (e) => {
          this.toast.notify({
            message: 'Erro ao buscar a foto do Aluno !',
            type: 'ERROR',
          });
          this.fotoFrontalCapturadaUrl = '';
        },
      });
  }

  getFotoUrlDireito(idFoto: number): any {
    this.loaderService
      .executeWithLoader(this.alunosService.buscarFotoPorId(idFoto))
      .subscribe({
        next: (blob: Blob) => {
          const url = URL.createObjectURL(blob);
          this.fotoDireitoCapturadaUrl = url;
        },
        error: (e) => {
          this.toast.notify({
            message: 'Erro ao buscar a foto do Aluno !',
            type: 'ERROR',
          });
        },
      });
  }

  getFotoUrlEsquerdo(idFoto: number): any {
    this.loaderService
      .executeWithLoader(this.alunosService.buscarFotoPorId(idFoto))
      .subscribe({
        next: (blob: Blob) => {
          const url = URL.createObjectURL(blob);
          this.fotoEsquerdoCapturadaUrl = url;
        },
        error: (e) => {
          this.toast.notify({
            message: 'Erro ao buscar a foto do Aluno !',
            type: 'ERROR',
          });
        },
      });
  }

  buscarAlunoPorId() {
    this.loaderService
      .executeWithLoader(
        this.alunosService.buscarAlunoPorIdPopulateFotos(
          this.documentIdAluno as string,
        ),
      )
      .subscribe({
        next: (value: any) => {
          this.aluno = value.data;
          if (value.data.foto_frontal !== null) {
            this.getFotoUrlFrontal(value.data.foto_frontal.id);
          }
          if (value.data.foto_direito !== null) {
            this.getFotoUrlDireito(value.data.foto_direito.id);
          }
          if (value.data.foto_esquerdo !== null) {
            this.getFotoUrlEsquerdo(value.data.foto_esquerdo.id);
          }
          // this.buscarTodasFotos(value.data.foto_frontal.id, value.data.foto_direito.id, value.data.foto_esquerdo.id);
          console.log(value.data);
        },
        error: (error) => {
          this.toast.notify({
            message: 'Tente novamente !',
            type: 'INFO',
          });
        },
      });
  }

  onFileSelectedFrontal(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.fotoFrontal = file; // Enviar a foto para o back

      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.fotoFrontalCapturadaUrl = e.target.result; // mostar no front
      };
      reader.readAsDataURL(file);
    }

    this.loaderService
      .executeWithLoader(
        this.filesService.uploadFile(
          this.fotoFrontal as File,
          this.aluno.id,
          contentType.ALUNO,
          field.FOTO_FRONTAL,
          'alunos/fotos',
        ),
      )
      .subscribe({
        next: (foto: any) => {
          this.toast.notify({ message: foto.message, type: 'SUCCESS' });
        },
        error: () => {
          this.toast.notify({
            message: 'Erro interno ao salvar foto Frontal. Tente novamente !',
            type: 'WARNING',
          });
        },
      });
  }

  onFileSelectedDireito(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.fotoDireito = file; // Enviar a foto para o back

      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.fotoDireitoCapturadaUrl = e.target.result; // mostar no front
      };
      reader.readAsDataURL(file);
    }

    this.loaderService
      .executeWithLoader(
        this.filesService.uploadFile(
          this.fotoDireito as File,
          this.aluno.id,
          contentType.ALUNO,
          field.FOTO_DIREITO,
          'alunos/fotos',
        ),
      )
      .subscribe({
        next: (foto: any) => {
          this.toast.notify({ message: foto.message, type: 'SUCCESS' });
        },
        error: () => {
          this.toast.notify({
            message: 'Erro interno ao salvar foto Direita. Tente novamente !',
            type: 'WARNING',
          });
        },
      });
  }

  onFileSelectedEsquerdo(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.fotoEsquerdo = file; // Enviar a foto para o back

      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.fotoEsquerdoCapturadaUrl = e.target.result; // mostar no front
      };
      reader.readAsDataURL(file);
    }

    this.loaderService
      .executeWithLoader(
        this.filesService.uploadFile(
          this.fotoEsquerdo as File,
          this.aluno.id,
          contentType.ALUNO,
          field.FOTO_ESQUERDO,
          'alunos/fotos',
        ),
      )
      .subscribe({
        next: (foto: any) => {
          this.toast.notify({ message: foto.message, type: 'SUCCESS' });
        },
        error: () => {
          this.toast.notify({
            message: 'Erro interno ao salvar foto Esquerda. Tente novamente !',
            type: 'WARNING',
          });
        },
      });
  }

  openFileFotoFrontal() {
    const fileInput = document.getElementById(
      'fileInputFotoFrontal',
    ) as HTMLInputElement;
    fileInput.click();
  }

  openFileFotoDireito() {
    const fileInput = document.getElementById(
      'fileInputFotoDireito',
    ) as HTMLInputElement;
    fileInput.click();
  }

  openFileFotoEsquerdo() {
    const fileInput = document.getElementById(
      'fileInputFotoEsquerdo',
    ) as HTMLInputElement;
    fileInput.click();
  }

  clearPhoto(lado: string) {
    if (lado === 'frontal') {
      this.fotoFrontalCapturadaUrl = undefined;
      this.fotoFrontal = undefined;
      this.aluno.foto_frontal = null;
    }
    if (lado === 'direito') {
      this.fotoDireitoCapturadaUrl = undefined;
      this.fotoDireito = undefined;
      this.aluno.foto_direito = null;
    }
    if (lado === 'esquerdo') {
      this.fotoEsquerdoCapturadaUrl = undefined;
      this.fotoEsquerdo = undefined;
      this.aluno.foto_esquerdo = null;
    }
  }
}
